import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import WebsiteFooter from 'src/Components/WebsiteComponents/WebsiteFooter';
import WebsiteHeader from 'src/Components/WebsiteComponents/WebsiteHeader';
import DiagnosticCartModal from 'src/Components/DiagnosticCartModal';
import WebGlobalSearch from 'src/Components/WebsiteComponents/WebGlobalSearch';

const WebsiteLayout: React.FC<{ children: ReactNode; }> = ({ children }) => {
    const notIncludeFooter = ["/doctor/login", "/doctor/register", "/doctor/forget-password", "/doctor/confirm-password", "/doctor/otp"]; // if footer not show then add the pathname like a "/login";
    const { pathname = "" } = useLocation();

    return (
        <>
            {
                !notIncludeFooter.includes(pathname) &&
                <WebsiteHeader />
            }
            {/* {!notIncludeSearch.includes(pathname) &&
                <div className='pharmacy-main-search'>
                    <WebGlobalSearch context={"website"} />
                </div>
            } */}
            {children}
            {!notIncludeFooter.includes(pathname) ?
                <WebsiteFooter />
                :
                null
            }
            <DiagnosticCartModal
                layout="webiste"
            />
        </>
    );
};

export default WebsiteLayout;